<template>
  <div class="alert alert-warning">
    <h3>Dados não encontrados</h3>
    <p>
      Verifique se o CPF e o primeiro nome foram digitados corretamente.
      <br />As pessoas que têm direito aos produtos são aquelas que já estavam em cadastros da Prefeitura de Belo Horizonte.
      <br />Para verificar se você se enquadra, acesse a página de dúvidas.
    </p>
    <p>Se ainda assim precisar de atendimento, acesse uma das opções de suporte.</p>
    <div class="d-block d-md-none">
      <botao-duvidas></botao-duvidas>
      <button class="btn btn-secondary btn-block" @click="responder()">Retornar</button>
    </div>
    <div class="d-none d-md-block">
      <div class="row">
        <botao-duvidas class="col-6"></botao-duvidas>
        <div class="col">
          <button class="btn btn-secondary btn-block" @click="responder()">Retornar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "msg-dados-invalidos",
  components: {
    "botao-duvidas": require("../layout/BotaoDuvidas").default
  },
  props: {
    bRetornoComDados: { type: Boolean, default: false }
  },
  methods: {
    responder() {
      if (this.bRetornoComDados) {
        this.$store.commit("registraRetornoComDados", true);
      } else {
        this.$store.dispatch("flushDados");
      }
      this.$router.push("/");
    }
  }
};
</script>

<style>
</style>